var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 323,
    viewBox: "0 0 433 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.823 34.0855C264.045 34.0855 215.579 82.501 215.579 142.216C215.579 165.73 223.296 187.307 236.123 204.977C236.353 205.4 236.389 205.874 236.65 206.279L308.813 314.41C312.16 319.424 317.797 322.434 323.823 322.434C329.849 322.434 335.486 319.424 338.833 314.41L410.996 206.279C411.262 205.874 411.293 205.4 411.523 204.977C424.35 187.307 432.067 165.73 432.067 142.216C432.067 82.501 383.601 34.0855 323.823 34.0855ZM323.823 178.26C303.897 178.26 287.742 162.121 287.742 142.216C287.742 122.311 303.897 106.173 323.823 106.173C343.749 106.173 359.904 122.311 359.904 142.216C359.904 162.121 343.749 178.26 323.823 178.26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 134.023C0 127.602 2.80505 121.502 7.67928 117.322L137.585 5.93005C145.825 -1.13552 157.987 -1.13554 166.227 5.93003L227 58.0427C208.201 81.4084 196.955 111.075 196.955 143.359C196.955 173.03 206.71 200.256 222.924 222.553C223.057 222.798 223.139 223.057 223.221 223.314C223.317 223.617 223.412 223.919 223.591 224.196L286.79 318.727C285.19 319.097 283.524 319.293 281.812 319.293H217.308C205.157 319.293 195.308 309.443 195.308 297.293V232.455C195.308 208.475 175.876 189.036 151.906 189.036C127.936 189.036 108.504 208.475 108.504 232.455V297.293C108.504 309.443 98.6545 319.293 86.5042 319.293H22C9.84973 319.293 0 309.443 0 297.293V134.023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.72fb70e62a5b4b6729555ad73105bd9b.svg";
export { ForwardRef as ReactComponent };